import "./AuditHistory.scss";

import Card from "components/Card/Card.tsx";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setValidationState } from "reducers/main.ts";
import {
  useGetClaimAuditHistoryQuery,
  useGetClaimByIdQuery,
  useGetClaimValidationsQuery,
} from "services/claims-api.ts";
import {
  setClaimsFormData,
  setCurrentClaim,
} from "services/claimsDataSlice.ts";
import type { ClaimsDataType } from "types/DataTypes.ts";
import { getTimeFromISOString } from "utils/date-utils";

import { nanoid } from "@reduxjs/toolkit";

import ClaimsPageContainer from "./ClaimsPageContainer";

const AuditHistory = () => {
  const { claimId } = useParams<{ claimId: string }>();
  const dispatch = useDispatch();

  const { data: auditHistory } = useGetClaimAuditHistoryQuery(
    { id: claimId },
    { skip: false },
  );

  const { data: claimValidation } = useGetClaimValidationsQuery(
    { id: claimId },
    { skip: !claimId },
  );

  const { data: claim, isLoading } = useGetClaimByIdQuery<{
    data: ClaimsDataType;
    isLoading: boolean;
  }>({ id: claimId }, { skip: !claimId });

  useEffect(() => {
    if (!isLoading) {
      dispatch(setClaimsFormData(claim));
      dispatch(setCurrentClaim(claim));
    }
  }, [dispatch, isLoading]);

  useEffect(() => {
    if (claimValidation) {
      dispatch(
        setValidationState({
          errors: claimValidation.filter((e) => e.level === "ERROR"),
          warnings: claimValidation.filter((e) => e.level === "WARN"),
        }),
      );
    }
  }, [claimValidation, dispatch]);

  return (
    <ClaimsPageContainer>
      <Card heading="Audit History">
        {(
          auditHistory as Array<{
            timestamp: string;
            action?: string;
            actor_username?: string;
            messages: string[];
            cause?: string;
          }>
        )?.map((item) => {
          const formattedDate = getTimeFromISOString(
            item.timestamp,
            "dateTime",
          );
          return (
            <div key={nanoid()} className="AuditHistory">
              <label className="AuditHistory--date">{formattedDate}</label>
              <div className="AuditHistory--audit">
                <div className="AuditHistory--audit--header">
                  {item.cause && `${item.cause} -`} Change by{" "}
                  {item.actor_username || "unknown"}
                </div>
                {item.messages.map((message) => (
                  <div key={nanoid()} className="AuditHistory--audit--item">
                    {message}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </Card>
    </ClaimsPageContainer>
  );
};

export default AuditHistory;
